/* ============================================================
   PROXIMO WISHLIST — global localStorage engine
   File: assets/proximo-wishlist.js
   Load in layout/theme.liquid with `defer` (see install notes).
   Stores product HANDLES in localStorage, newest first.
   Public API: window.ProximoWishlist
   Fires:      'proximo:wishlist:change' on document
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'proximo_wishlist';

  /* ---------- storage helpers ---------- */
  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.filter(function (h) { return typeof h === 'string' && h.length; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(items));
    } catch (e) {
      /* storage full or blocked — fail silently */
    }
    emit();
  }

  function emit() {
    document.dispatchEvent(new CustomEvent('proximo:wishlist:change', {
      detail: { items: read(), count: read().length }
    }));
  }

  /* ---------- public API ---------- */
  var ProximoWishlist = {
    get items() { return read(); },
    get count() { return read().length; },

    has: function (handle) {
      return read().indexOf(handle) !== -1;
    },

    add: function (handle) {
      if (!handle) return;
      var items = read();
      if (items.indexOf(handle) === -1) {
        items.unshift(handle); /* newest first */
        write(items);
      }
    },

    remove: function (handle) {
      var items = read().filter(function (h) { return h !== handle; });
      write(items);
    },

    toggle: function (handle) {
      if (!handle) return;
      this.has(handle) ? this.remove(handle) : this.add(handle);
    }
  };

  window.ProximoWishlist = ProximoWishlist;

  /* ---------- UI sync ---------- */
  function syncButtons() {
    var buttons = document.querySelectorAll('[data-wishlist-button]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var inList = ProximoWishlist.has(btn.getAttribute('data-handle'));
      btn.classList.toggle('is-in-wishlist', inList);
      btn.setAttribute('aria-pressed', inList ? 'true' : 'false');
    }
  }

  function syncBadges() {
    var count = ProximoWishlist.count;
    var badges = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count;
      badges[i].classList.toggle('is-empty', count === 0);
    }
  }

  function syncAll() {
    syncButtons();
    syncBadges();
  }

  /* ---------- delegated click handler ---------- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-wishlist-button]');
    if (!btn) return;
    event.preventDefault();
    ProximoWishlist.toggle(btn.getAttribute('data-handle'));
  });

  /* ---------- keep everything in sync ---------- */
  document.addEventListener('proximo:wishlist:change', syncAll);

  /* other tabs of the same browser */
  window.addEventListener('storage', function (event) {
    if (event.key === KEY) syncAll();
  });

  /* sections re-rendered by the theme editor */
  document.addEventListener('shopify:section:load', syncAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
})();
